import { Dimension, Widget } from '../models/core.models';
import { createAction, props } from '@ngrx/store';

import { WidgetOperation } from '../models/widget-operations';

// * broadcast only - the write is `WidgetPersistenceService.updateWidget`
export const updateWidgetSuccess = createAction(
  '[Widget] Update Widget Success',
  props<{ widgetId: string; data: any }>(),
);

// * broadcast only - the write is `WidgetPersistenceService.massUpdateWidgets`
export const massUpdateWidgetsSuccess = createAction(
  '[Widget] Mass Update Widgets Success',
  props<{
    widgetIds: string[];
    data: any;
    countUpdated: number;
    widgets?: Widget[];
  }>(),
);

/**
 * Broadcast only - the request is `WidgetPersistenceService.createWidget`, which
 * derives row/placeholder geometry from the list query and invalidates it.
 */
export const createWidgetSuccess = createAction(
  '[Widget] Create Widget Success',
  props<{ widget: Widget; objectClassId: number }>(),
);

export const createWidgetFail = createAction(
  '[Widget] Create Widget Fail',
  props<{ error: any }>(),
);

// * broadcast only - the write is `WidgetPersistenceService.deleteWidget`
export const deleteWidgetSuccess = createAction(
  '[Widget] Delete Widget Success',
  props<{ widgetId: string }>(),
);

/**
 * Client state only - the write is `WidgetPersistenceService.deleteWidgets`. This
 * still fires so the reducer raises `loadingWidgets` for the widget-area spinner,
 * which `deleteWidgetsSuccess` / `deleteWidgetsFail` lower again.
 */
export const deleteWidgets = createAction(
  '[Widget] Delete Widgets',
  props<{ widgetIds: string[] }>(),
);

export const deleteWidgetsSuccess = createAction(
  '[Widget] Delete Widgets Success',
  props<{ widgetIds: string[] }>(),
);

export const deleteWidgetsFail = createAction(
  '[Widget] Delete Widgets Fail',
  props<{ error: any }>(),
);

export const searchWidgets = createAction(
  '[Widget] Search Widgets',
  props<{ query: string }>(),
);

export const toggleWidgetViewOption = createAction(
  '[Widget] Toggle Widget View Option',
  props<{ optionName: string }>(),
);

export const selectWidgetPlaceholderId = createAction(
  '[Widget] Select Widget Placeholder Id',
  props<{ id: string }>(),
);

export const activatePivotFeed = createAction(
  '[Widget] Activate Pivot Feed',
  props<{ widgetId: string; pivotFeedId: string }>(),
);

export const activatePivotFeedSuccess = createAction(
  '[Widget] Activate Pivot Feed Success',
  props<{ widgetId: string; dimension: Dimension }>(),
);

export const activatePivotFeedFail = createAction(
  '[Widget] Activate Pivot Feed Fail',
  props<{ widgetId: string; error: any }>(),
);

// * Mass Widget Operations - unified copy/move
// * broadcast only - the write is `WidgetPersistenceService.massOperation`
export const widgetMassOperationSuccess = createAction(
  '[Widget] Mass Operation Success',
  props<{ operations: WidgetOperation[] }>(),
);

export const htmlWidgetClicked = createAction(
  '[HTML Widget] Clicked',
  props<{ payload: any }>(),
);

export const widgetPointClicked = createAction(
  '[Widget] Point Clicked',
  props<{
    widgetId: string;
    options: {
      datetime?: boolean;
      name?: string;
      value_name?: string;
      raw?: string;
      property_uri?: string;
      pivot_query_id?: number;
      zoom_start?: number;
      zoom_end?: number;
      is_reset_zoom?: boolean;
    };
  }>(),
);

export const widgetPointClickedResolved = createAction(
  '[Widget] Point Clicked Resolved',
  props<{ widgetId: string; options: any; widget: Widget }>(),
);

